<template>
    <section class="hero">
        <div class="hero-body">
            <div class="container">
                <h1 class="title" style="text-align:center">
                    {{ title }}
                </h1>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'HeroContainer',
    props: {
        title: {
            type: String,
            required: true
        }
    }
}
</script>